import React from 'react'
import PageList from '../../../components/PageListAPI'
import { getWeldersList, deleteWeldersById } from '../../../api/welding.api'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';
export default function WeldersList(props) {
  const can = useCan()
  return <div className='App-paper'>
    <PageList
      name='welders-list'
      title='Список сварщиков,  выполнявших сварочные работы на объекте  '
      columns={[
        { id: 'fullName', name: 'Фамилия, имя, отчество', },
        { id: 'qualification', name: 'Разряд квалификационный', },
        { id: 'stamp', name: 'Номер личного клейма', },
        { id: 'certificatesNumber', name: 'Удостоверение номер', },
        { id: 'certificatesDate', name: 'Удостоверение срок действия', type: 'date', formatDate: 'DD.MM.YYYY' },
        { id: 'certificatesSeams', name: 'Удостоверение шов', },
        { id: 'markTest', name: 'Отметка  о сварке пробных  и контрольных образцов', },
      ]}
      createItem={can(SLUGS.PROJECT.WELDING.MANAGE)}
      deleteItem={can(SLUGS.PROJECT.WELDING.MANAGE)}
      loadAPI={{
        request: getWeldersList,
        querty: {
        },
        param: {
          id: props.match.params.idProject
        },
      }}
      click={false}
      deleteAPI={deleteWeldersById(props.match.params.idProject)}
      {...props}
    />
  </div>
}